import React, { useState } from 'react';
import { Nav } from 'react-bootstrap';
import AdminProducts from './AdminProducts';
import WebhookEventLog from '../Component/WebhookEventLog';

const AdminDashboard = () => {
  const [active, setActive] = useState('products');
  const apiBase = process.env.REACT_APP_API_BASE || 'http://localhost:4000';

  return (
    <div className="container" style={{ marginTop: 24 }}>
      <h2>Admin Dashboard</h2>
      <p className="text-muted">Manage products, orders and inventory from here.</p>

      <Nav variant="tabs" activeKey={active} onSelect={k => setActive(k)} className="mb-3">
        <Nav.Item>
          <Nav.Link eventKey="products">Products</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="orders">Orders</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="inventory">Inventory</Nav.Link>
        </Nav.Item>
      </Nav>

      {active === 'products' && (
        <section>
          <AdminProducts />
          <WebhookEventLog apiBase={apiBase} />
        </section>
      )}

      {active === 'orders' && (
        <section>
          <h4>Orders</h4>
          <p>View and manage orders (scaffold).</p>
        </section>
      )}

      {active === 'inventory' && (
        <section>
          <h4>Inventory</h4>
          <p>Adjust stock levels and view inventory history (scaffold).</p>
        </section>
      )}
    </div>
  );
};

export default AdminDashboard;
